import React from 'react';

import { validate } from 'validate.js';
import { Row, Col, Modal, Button, Input, Divider, Form } from 'antd';
import { _success, _setAxios, _validationFormMsg } from '../../../../lib/Helper';
import { SelectAspekKategoriUbudiyah } from '../../../../components/select';

const schema = {
    nama: {
        presence: { allowEmpty: false, message: 'wajib diisi' },
    },
    ubudiyah_kategori_id: {
        presence: { allowEmpty: false, message: 'wajib dipilih' },
    },
};

class FormContent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,

            visible: false,
        };
    }

    componentDidMount() {
        this.setState({
            values: {
                id: this.props.data ? this.props.data.id : null,
                nama: this.props.data ? this.props.data.nama : null,
                ubudiyah_kategori_id: this.props.data ? this.props.data.ubudiyah_kategori_id : null,
            },
        })
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        const errors = validate(values, schema);

        console.log("values----", values)

        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    handleSubmit = async () => {
        const { values } = this.state
        const errors = validate(values, schema);
        if (errors) {
            return _validationFormMsg(errors)
        }
        this.setState({
            loading: true
        });
        const params = {
            nama: values.nama ? values.nama : null,
            ubudiyah_kategori_id: values.ubudiyah_kategori_id ? values.ubudiyah_kategori_id : null,
        }

        let endpoint = "ubudiyah/aspek"
        let method = "POST"
        if (values.id) {
            endpoint = endpoint + "/" + values.id
            method = "PUT"
        }

        _setAxios(endpoint, method, params).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.props.fetchTable(true)
                this.props.hideModal()

                this.setState({
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                });
            }
        })
    };

    render() {

        const { values } = this.state
        const data = this.props.data

        return (
            <Modal
                maskClosable={false}
                title={"Form Aspek Penilaian Ubudiyah"}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                closable={false}
                footer={null}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={this.handleSubmit}
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24}>
                            <Form.Item label="Nama Aspek *">
                                <Input
                                    style={{ width: '100%' }}
                                    name="nama"
                                    placeholder="Nama"
                                    defaultValue={data.nama}
                                    value={values.nama || null}
                                    onChange={(e) => {
                                        this.handleChangeSetValue("nama", e.target.value)
                                    }} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} >
                            <Form.Item label="Aspek Kategori *">
                                <SelectAspekKategoriUbudiyah
                                    modul="aspek penilaian"
                                    defaultValue={data.ubudiyah_kategori_id}
                                    value={values.ubudiyah_kategori_id}
                                    onChange={(val) => {
                                        this.handleChangeSetValue("ubudiyah_kategori_id", val ? val : null)
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} style={{ textAlign: "right" }}>
                            <Divider />
                            <Button onClick={this.props.hideModal}>Batal</Button> &nbsp;
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>Simpan</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default FormContent;
